export const AllRoutes = {
    home: "/",
    programming: "/programming",
    aboutUs: "/about-us",
    gallery: "/gallery",
    userLogin: "/login",
    staff: "/staff",
    admin: "/admin/login",
    posts: "/post/",
    adminDashboard: "/admin/dashboard/home",
    adminChat: "/admin/dashboard/customers-chat",
    adminUsers: "/admin/dashboard/user-management",
    adminPublish: "/admin/dashboard/Publish",
    adminSponsors: "/admin/dashboard/sponsors",
    adminProgramming: "/admin/dashboard/programming",
    adminInfo: "/admin/dashboard/app-info",
    blocked: '/error/blocked-user',
    any: "*"
}
